import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useCallback, useState, Suspense, useMemo } from "react";
import { BisnodeSearch } from "./BisnodeSearch";
import { DployAutocomplete, useFieldToTextField } from "@ploy-ui/form-fields";
import { FormattedMessage, defineMessages, useIntl } from "react-intl";
import CloseIcon from "@material-ui/icons/Close";
import { makeStyles } from "@material-ui/core/styles";
import Modal from "@material-ui/core/Modal";
import Backdrop from "@material-ui/core/Backdrop";
import Fade from "@material-ui/core/Fade";
import CircularProgress from "@material-ui/core/CircularProgress";
import Card from "@material-ui/core/Card";
import CardHeader from "@material-ui/core/CardHeader";
import CardContent from "@material-ui/core/CardContent";
import IconButton from "@material-ui/core/IconButton";
import { createFilterOptions } from "@material-ui/lab/Autocomplete";
import { BaseCamelCasedResource } from "@ploy-lib/rest-resources";
import { legacyApiResourceUrl } from "@ploy-lib/core";
import { useResource } from "@rest-hooks/core";
class CustomerSettingsResource extends BaseCamelCasedResource {
    pk() {
        return "singleton";
    }
    static url(urlParams) {
        return this.listUrl(urlParams);
    }
}
CustomerSettingsResource.urlRoot = legacyApiResourceUrl("AppLoanLeasing/GetCustomerSettings");
const useStyles = makeStyles(theme => ({
    modal: {
        display: "flex",
        alignItems: "center",
        justifyContent: "center"
    },
    card: {
        flexBasis: 1000,
        maxHeight: "100vh",
        overflowY: "auto"
    }
}));
const messages = defineMessages({
    bisnodeOption: {
        id: "ploy-ui.core.bisnodeSearch.bisnode-option.label",
        description: "Label of bisnode search option in select",
        defaultMessage: "name search in bisnode ..."
    },
    closeLabel: {
        id: "ploy-ui.core.bisnodeSearch.modal.close.label",
        description: "Label of modal close button",
        defaultMessage: "Close"
    }
});
export function BisnodeSearchField(props) {
    const { onSelectItem, valueKey, labelKey, emptyEqualsZero, options, formatString, italicText, boldText, multiple, form: { setFieldValue }, field, errorDisplay, modalText, ...rest } = props;
    const customerSettings = useResource(CustomerSettingsResource.detail(), {});
    const showBisnodeSearch = Boolean(customerSettings && customerSettings.displayBisnodeSearch);
    const [open, setOpen] = useState(false);
    const intl = useIntl();
    const bisnodeOption = intl.formatMessage(messages.bisnodeOption);
    const onChange = useCallback((e, selected) => {
        if (typeof selected === "string" && selected === bisnodeOption) {
            setOpen(true);
        }
        else {
            if (onSelectItem)
                onSelectItem(selected);
        }
    }, [bisnodeOption, onSelectItem]);
    const onInputChange = useCallback((e, value) => {
        if (e && e.type === "change")
            setFieldValue(field.name, value);
    }, [field.name, setFieldValue]);
    const onBisnodeSelect = useCallback((companyNumber) => {
        setOpen(false);
        setFieldValue(field.name, companyNumber);
        if (onSelectItem)
            onSelectItem(companyNumber);
    }, [field.name, setFieldValue, onSelectItem]);
    const { autoComplete, value, ...textFieldProps } = useFieldToTextField(props);
    const classes = useStyles();
    const defaultFilter = useMemo(() => createFilterOptions(), []);
    const filterOptionsWithBisnode = useCallback((options, state) => [
        ...defaultFilter(options, state),
        bisnodeOption
    ], [bisnodeOption, defaultFilter]);
    if (!showBisnodeSearch)
        return (_jsx(DployAutocomplete, { ...rest, ...textFieldProps, value: value, onChange: onChange, onInputChange: onInputChange, inputValue: value ? String(value) : "", searchable: true, minSearch: 3, autoSelect: false, autoHighlight: false, removeNoOptionsMessage: true, defaultValue: undefined }));
    return (_jsxs(_Fragment, { children: [_jsx(DployAutocomplete, { ...rest, ...textFieldProps, value: value, onChange: onChange, onInputChange: onInputChange, inputValue: value ? String(value) : "", searchable: true, minSearch: 3, autoSelect: false, autoHighlight: false, removeNoOptionsMessage: true, AutocompleteProps: {
                    filterOptions: filterOptionsWithBisnode
                }, defaultValue: undefined }), _jsx(Modal, { "aria-labelledby": "bisnode-search-modal-title", "aria-describedby": "bisnode-search-modal-description", className: classes.modal, open: open, onClose: () => setOpen(false), closeAfterTransition: true, BackdropComponent: Backdrop, BackdropProps: {
                    timeout: 500
                }, children: _jsx(Fade, { in: open, children: _jsx(Suspense, { fallback: _jsx(CircularProgress, {}), children: _jsxs(Card, { className: classes.card, children: [_jsx(CardHeader, { title: _jsx(FormattedMessage, { id: "ploy-ui.core.bisnodeSearch.modalTitle.text", description: "Title of bisnode search modal", defaultMessage: "Name Search" }), subheader: _jsx(FormattedMessage, { id: "ploy-ui.core.bisnodeSearch.modal.description", description: "Description of bisnode search modal", defaultMessage: "Search by company" }), action: _jsx(IconButton, { onClick: () => setOpen(false), "aria-label": intl.formatMessage(messages.closeLabel), children: _jsx(CloseIcon, {}) }) }), _jsx(CardContent, { children: _jsx(BisnodeSearch, { initialSearchValue: field.value, onSelect: onBisnodeSelect }) })] }) }) }) })] }));
}
//# sourceMappingURL=BisnodeSearchField.js.map